import { LED_COLORS, LED_COLOR_KEYS } from '@/lib/tournamentsMidi'

/* Kies één van de 11 mk2-kleuren. `value` = LED-naam (bv. 'red'), `onChange`
   krijgt de nieuwe naam. De swatch toont exact wat de pad zal branden. */
const OPTIES = LED_COLOR_KEYS.filter(k => !k.endsWith('_blink') && k !== 'off')

export default function LedColorPicker({ value, onChange, label }) {
  return (
    <div>
      {label && (
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">
          {label}
        </div>
      )}
      <div className="flex gap-2 flex-wrap">
        {OPTIES.map(k => {
          const swatch = LED_COLORS[k].swatch
          const geselecteerd = value === k
          return (
            <button key={k} type="button" onClick={() => onChange(k)}
                    title={k}
                    className="group flex flex-col items-center gap-1 min-w-[3.5rem]">
              <span className="h-10 w-10 rounded-[4px] border-2 transition-transform group-hover:scale-105"
                    style={{
                      background: swatch,
                      borderColor: geselecteerd ? 'var(--acid, #B4FF39)' : 'transparent',
                      boxShadow: geselecteerd ? `0 0 0 1px var(--background, #000), 0 0 12px ${swatch}66` : 'none',
                    }} />
              <span className={`font-mono text-[9px] uppercase tracking-widest ${geselecteerd ? 'text-foreground' : 'text-muted-foreground'}`}>
                {k}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
